import React, { useEffect, useState } from "react";
import { getVenueConfirmation, submitVenueConfirmation } from "../watchApi.js";
import "./venue-confirmation.css";

const teamName = (team) => typeof team === "string" ? team : team?.name || "Team";

export function VenueConfirmationPage() {
  const token = new URLSearchParams(window.location.search).get("token");
  const [state, setState] = useState({ status: "loading" });

  useEffect(() => {
    if (!token) { setState({ status: "error", message: "This confirmation link is incomplete." }); return; }
    getVenueConfirmation(token)
      .then((data) => setState(data.status === "used" ? { status: "used", data } : { status: "ready", data }))
      .catch((error) => setState({ status: "error", message: error.message }));
  }, [token]);

  async function answer(value) {
    setState((current) => ({ ...current, status: "saving" }));
    try {
      const result = await submitVenueConfirmation(token, value);
      setState({ status: "recorded", answer: result.answer });
    } catch (error) {
      setState({ status: "error", message: error.message });
    }
  }

  const data = state.data;
  return <main className="venue-confirmation-page">
    <section className="venue-confirmation-card" aria-live="polite">
      <a className="venue-confirmation-brand" href="/" aria-label="Fadius home">
        <img src="/brand/downloads/fadius-horizontal-lockup-transparent.png" alt="Fadius" />
      </a>
      {state.status === "loading" && <><h1>Checking your link…</h1><p>One moment.</p></>}
      {state.status === "ready" || state.status === "saving" ? <>
        <p className="venue-confirmation-kicker">Match confirmation</p>
        <h1>Are you showing this match?</h1>
        <div className="venue-confirmation-match">
          <strong>{teamName(data.event.homeTeam)} vs. {teamName(data.event.awayTeam)}</strong>
          <span>{data.venue.name}</span>
          <time dateTime={data.event.startsAt}>{new Date(data.event.startsAt).toLocaleString([], { dateStyle: "medium", timeStyle: "short" })}</time>
        </div>
        <p>Your answer updates this match only. The link expires and can be used once.</p>
        <div className="venue-confirmation-actions">
          <button disabled={state.status === "saving"} onClick={() => answer("yes")}>Yes, we're showing it</button>
          <button className="secondary" disabled={state.status === "saving"} onClick={() => answer("no")}>No, we're not</button>
        </div>
      </> : null}
      {state.status === "recorded" && <><h1>Thanks — recorded.</h1><p>{state.answer === "yes" ? "Fans can now see this match as venue-confirmed." : "This match will not appear as confirmed at your venue."}</p></>}
      {state.status === "used" && <><h1>This link has already been used.</h1><p>If the answer needs to change, reply to the Fadius email that sent it.</p></>}
      {state.status === "error" && <><h1>We couldn't use this link.</h1><p>{state.message}</p><p>Reply to the Fadius email that sent it and we'll help.</p></>}
    </section>
  </main>;
}
